/**
 * フォントサイズ切替（再利用向け・属性駆動）
 *
 * 使い方メモ
 * - 切替ボタンは「ユーザーが実際にクリックする要素（クリックイベントが拾える要素）」に
 *   data-fontsize-set を付けてください（button / a / label などが安全）。
 *   ※このスクリプトはクリック位置から closest("[data-fontsize-set]") で探します。
 *
 * - この方式は html の font-size(%) を切り替えるため、文字サイズ指定が rem/em/% 等の要素に効きます。
 *   一方で px / vw(vh等) で固定している font-size には基本的に効きません（意図的に固定したい箇所向け）。
 *
 * 使い方（例）
 * - 切替ボタン（label/button/span等）に data-fontsize-set="100" / "112.5" を付ける
 * - 任意で <html> に設定を付けられる:
 *   - data-fontsize-storage-key="site.fontsize"
 *   - data-fontsize-media="(min-width: 769px)"  // PCのみ適用
 *   - data-fontsize-default="100"
 */
(() => {
  const root = document.documentElement;
  if (!root) return;

  const storageKey = root.dataset.fontsizeStorageKey || "ui.fontSizePercent";
  const defaultValue = root.dataset.fontsizeDefault || "100";
  const mediaQuery = root.dataset.fontsizeMedia || "(min-width: 769px)";

  const mql = window.matchMedia ? window.matchMedia(mediaQuery) : null;

  const normalizePercent = (raw) => {
    if (raw == null) return null;
    const s = String(raw).trim();
    if (!s) return null;
    return s.endsWith("%") ? s : `${s}%`;
  };

  const load = () => {
    try {
      return localStorage.getItem(storageKey) || defaultValue;
    } catch {
      return defaultValue;
    }
  };

  const save = (value) => {
    try {
      localStorage.setItem(storageKey, String(value));
    } catch {
      // localStorage が使えない環境でも最低限動作させる
    }
  };

  const setPressedState = (activeRawValue) => {
    const all = document.querySelectorAll("[data-fontsize-set]");
    all.forEach((el) => {
      const v = el.getAttribute("data-fontsize-set");
      const isActive = String(v) === String(activeRawValue);
      // button だけでなく label/span でも使えるように aria-pressed を付与
      el.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  };

  const syncRadioFromTrigger = (trigger) => {
    if (!trigger) return;
    // label[for] をクリックした場合、対応する radio を checked にする（見た目・既存CSSを維持）
    if (trigger.tagName === "LABEL") {
      const id = trigger.getAttribute("for");
      if (!id) return;
      const input = document.getElementById(id);
      if (input && input instanceof HTMLInputElement && input.type === "radio") {
        input.checked = true;
      }
    }
  };

  const apply = (rawValue) => {
    const value = rawValue ?? defaultValue;

    // PCのみ適用。SPでは inline を消してブラウザ既定 / CSS に戻す
    if (mql && !mql.matches) {
      root.style.fontSize = "";
      setPressedState(value);
      return;
    }

    const percent = normalizePercent(value);
    if (!percent) return;

    root.style.fontSize = percent;
    setPressedState(value);
  };

  // 初期適用（保存値があれば復元）
  apply(load());

  // 画面幅変更に追随（PC<->SP）
  if (mql && typeof mql.addEventListener === "function") {
    mql.addEventListener("change", () => apply(load()));
  } else if (mql && typeof mql.addListener === "function") {
    // Safari 互換
    mql.addListener(() => apply(load()));
  }

  // クリック（イベント委譲）
  document.addEventListener("click", (e) => {
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    const trigger = target.closest("[data-fontsize-set]");
    if (!trigger) return;

    const rawValue = trigger.getAttribute("data-fontsize-set");
    if (!rawValue) return;

    syncRadioFromTrigger(trigger);
    save(rawValue);
    apply(rawValue);
  });
})();

